import { css } from 'styled-components'

const max = 'max-width'
const min = 'min-width'

/* eslint-disable */
const mediaQueryConfig = [
  { label: 'doubleExtraLarge', size: 1200, query: min },
  { label: 'extraLarge', size: 1200, query: max },
  { label: 'large', size: 992, query: max },
  { label: 'medium', size: 768, query: max },
  { label: 'small', size: 576, query: max },
  { label: 'fontMax', size: 1024, query: max },
  { label: 'fontMin', size: 360, query: min },
  { label: 'desktop', size: 576, query: min },
]
/* eslint-enable */

const mediaQuery = mediaQueryConfig.reduce((acc, item) => {
  const { label, size, query } = item
  const emSize = size / 16

  // eslint-disable-next-line
  acc[label] = (...args) => css`
    @media (${query}: ${emSize}em) {
      ${css(...args)}
    }
  `
  return acc
}, {})

export const breakpoints = { mobile: 599, tablet: 839 }
export const widthRules = {
  mobile: `(max-width: ${breakpoints.mobile}px)`,
  tablet: `(min-width: ${breakpoints.mobile + 1}px) and (max-width: ${breakpoints.tablet}px)`,
  desktop: `(min-width: ${breakpoints.tablet + 1}px)`,
}

export default mediaQuery
